<template>
  <v-card class="elevation-0 details-layout__content">
    <v-card-title>
      <v-layout row wrap class="payments-layout__menu py-1">
        <v-flex sm10>
          <span class="menu-item">
            <router-link :to="{ name: 'paymentsWeekly' }">
              Weekly
            </router-link>
          </span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink v-if="querySearch === 'overdue' || querySearch === 'current_week'">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                small
                class="align--right ma-0"
                @click="processSelectedPayments"
                v-on="on"
              >
                <v-icon class="mr-1" color="success">done_outline</v-icon>
              </v-btn>
            </template>
            <span>Mark payments as processed</span>
          </v-tooltip>
        </v-flex>
        <v-flex shrink class="mr-2" v-if="querySearch === 'processed' || querySearch === 'bankfiled'">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                small
                class="align--right ma-0"
                @click="downloadBankFile(selectedPayments)"
                v-on="on"
              >
                <v-icon class="mr-1" color="primary">reorder</v-icon>
              </v-btn>
            </template>
            <span>Generate bank file</span>
          </v-tooltip>
        </v-flex>
        <v-flex shrink v-if="querySearch === 'bankfiled'">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                small
                class="align--right ma-0"
                @click="sendPaymentStatements"
                v-on="on"
              >
                <v-icon class="mr-1" color="warning">archive</v-icon>
              </v-btn>
            </template>
            <span>Send payment statements</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md px-0>
        <v-layout row wrap>
          <v-flex xs2 class="details-layout__menu details-layout__menu--vertical">
            <v-navigation-drawer permanent stateless>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="menu-item">
                      <div class="body-1" style="padding: 0 10px">Unprocessed</div>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="menu-item" style="padding: 0 10px">
                      <router-link :to="{ query: {search:'overdue'}}" class="body-1">- Overdue</router-link>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="menu-item" style="padding: 0 10px">
                      <router-link :to="{ query: {search:'current_week'}}" class="body-1">- Current week</router-link>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="menu-item">
                      <router-link :to="{ query: { search: 'processed' } }" class="body-1">Processed</router-link>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="menu-item">
                      <router-link :to="{ query: { search: 'bankfiled' } }" class="body-1">Bank Filed</router-link>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="menu-item">
                      <router-link :to="{ query: { search: 'all' } }" class="body-1">All</router-link>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-flex>
          <v-flex xs10 class="pa-3">
            <div ref="paymentsChild">
              <v-layout row wrap v-if="querySearch === 'all'">
                <v-flex sm4>
                  <v-layout row>
                    <v-flex align-self-center>
                      <v-icon large>calendar_today</v-icon>
                    </v-flex>
                    <v-flex grow>
                      <v-menu
                        v-model="displayFilterStartDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="filterStartDate"
                            label="Select Start Date"
                            readonly
                            :rule="dateRules"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startDate"
                          no-title
                          @input="displayFilterStartDate = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm4>
                  <v-layout row>
                    <v-flex align-self-center shrink>
                      <v-icon large>calendar_today</v-icon>
                    </v-flex>
                    <v-flex grow>
                      <v-menu
                        v-model="displayFilterEndDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="filterEndDate"
                            label="Select End Date"
                            readonly
                            :rule="dateRules"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          no-title
                          @input="displayFilterEndDate = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm4>
                  <v-btn color="primary" @click.stop="getPayments(getPaymentParameters('all'))">
                    Submit
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-data-table
                v-model="selectedPayments"
                :headers="headers"
                :items="payments"
                select-all
                item-key="id"
                :rows-per-page-items="rowsPerPage"
                class="table--fixed"
                @update:pagination="updatePagination"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th style="width: 6%; padding: 0 2px;">
                    <v-layout row>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn flat icon small class="align--left ma-0" @click="toggleAll" v-on="on">
                            <v-icon class="mr-1" :color="selectedPayments.length? 'primary': 'secondary'">select_all</v-icon>
                          </v-btn>
                        </template>
                        <span>Toggle the selection for all items</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-checkbox
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.stop="toggleCurPage"
                            v-on="on"
                          ></v-checkbox>
                        </template>
                        <span>Toggle the selection for current page</span>
                      </v-tooltip>
                    </v-layout>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      class="text-xs-left"
                      :style="{ width: header.width }"
                    >
                      <span class="font-weight-bold">{{ header.text }}</span>
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr @click="showPayment(props.item, $event)" class="payment-row" :set="payment = props.item">
                    <td>
                      <v-checkbox
                        :disabled="!payment.id"
                        :input-value="props.selected"
                        primary
                        hide-details
                        @change="props.selected = !props.selected"
                      ></v-checkbox>
                    </td>
                    <td :set="house = props.item">
                      {{
                      (house.unit ? [house.unit, house.num].join('/') : house.num) +
                          ' ' + house.street +
                          ', ' + house.suburb
                      }}
                    </td>
                    <td>{{ payment.paydue_time | moment('D/MM/YYYY') }}</td>
                    <td>{{ payment.paystart_time | moment('D/MM/YYYY') }}</td>
                    <td>{{ payment.payend_time | moment('D/MM/YYYY') }}</td>
                    <td>{{ '$' + payment.pay_amount }}</td>
                    <td :style="{color: payment.color}">{{payment.display_amount}}</td>
                    <td>
                      <v-layout row>
                        <v-tooltip left v-for="v in [details(payment)]">
                          <template v-slot:activator="{ on }">
                            <v-icon :color="v.iconColor" v-on="on">done_outline</v-icon>
                          </template>
                          <span>{{v.tooltip}}</span>
                        </v-tooltip>
                        <v-tooltip right v-if="payment.disactived && payment.disactived.length > 0">
                          <template v-slot:activator="{ on }">
                            <v-icon color="red" v-on="on">feed</v-icon>
                          </template>
                          <span>Disactive fees in payment</span>
                        </v-tooltip>
                        <v-tooltip right v-if="payment.fee && payment.fee.length > 0">
                          <template v-slot:activator="{ on }">
                            <v-icon color="green" v-on="on">feed</v-icon>
                          </template>
                          <span>Fees in payment</span>
                        </v-tooltip>
                      </v-layout>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <PaymentDlg ref="PaymentDlg"/>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import paymentHelper from '@/helpers/payment'
  import alertHelper from '@/helpers/alert'
  import moment from 'moment'

  export default {
    name: 'PaymentsWeekly',
    components: {
      PaymentDlg: () => import('@/components/houselist/details/Payment'),
    },
    data() {
      return {
        headers: [
          {
            text: 'Address',
            align: 'left',
            sortable: false,
            value: 'address',
            width: '30%'
          },
          {
            text: 'Pay Due Date',
            align: 'left',
            sortable: false,
            value: 'paydue_time',
            width: '10%'
          },
          {
            text: 'Pay From Date',
            align: 'left',
            sortable: false,
            value: 'paystart_time',
            width: '10%'
          },
          {
            text: 'Pay To Date',
            align: 'left',
            sortable: false,
            value: 'payend_time',
            width: '10%'
          },
          { text: 'Rent ($)',
            align: 'left',
            sortable: false,
            value: 'pay_amount',
            width: '10%'
          },
          { text: 'Payment ($)',
            align: 'left',
            sortable: false,
            value: 'total_amount',
            width: '10%'
          },
          { text: 'Status',
            align: 'left',
            sortable: false,
            value: 'status',
            width: '10%'
          },
        ],
        selectedPayments: [],
        selectedPayment: {},
        pagination: {},
        showSummary: false,
        rowsPerPage: [20, 50, 100, {text:"$vuetify.dataIterator.rowsPerPageAll", value: 20}],
        startDate: moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        displayFilterStartDate: false,
        displayFilterEndDate: false,
        dateRules: [
          (v) => !!v || 'Date is required',
          (v) =>
            /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}:$/.test(v) ||
            'Date must be valid',
        ],
      }
    },
    computed: {
      ...mapGetters({
        leaseList: 'LeaseList/getAll',
        querySearch: 'Payments/getQuerySearch',
        storePayments: 'Payments/getPayments'
      }),
      payments() {
        const payments = this.storePayments

        if (payments.length > 0) {
          payments.map(payment => {
            if (+payment.state === 0) {
              payment.display_amount = ''
            } else {
              payment.display_amount = `$${payment.total_amount.toFixed(2)}`
              payment.color= (payment.total_amount >= 0)? 'black': 'red'
            }
            return payment
          })
        }

        let p = payments.find(payment => payment.house_id === 92)
        console.log('Weekly', {p})
        return payments
      },
      filterStartDate() {
        return this.formatDate(this.startDate)
      },
      filterEndDate() {
        return this.formatDate(this.endDate)
      }

    },
    watch: {
      $route(to, from) {
        if (to.query.search) {
          console.log('to.query.search =', to.query.search)
          this.getPayments({querySearch: to.query.search})
        }
      }
    },
    deactivated() {
      this.selectedPayment = {}
    },
    methods: {
      ...mapMutations({
        setSelectedPayment: 'Payments/setSelectedPayment',
      }),
      ...mapActions({
        updateMany: 'Payments/bulkUpdate',
        downloadBankFile: 'Payments/downloadBankFile',
        sendPayment: 'Payments/sendPayment',
        processPayments: 'Payments/processPayments',
        getLastBalance: 'HouseList/Payments/getLastBalance',
        fetchLeaseList: 'LeaseList/fetch',
        getPayments: 'Payments/getPayments',
      }),
      toggleAll() {
        // console.log({rowsPerPage:this.rowsPerPage})
        if (this.selectedPayments.length) {
          this.selectedPayments = []
        } else {
          this.selectedPayments = this.payments.filter(this.shouldSelect).slice()
        }
      },
      toggleCurPage() {
        if (!this.pagination) {
          return;
        }
        const firstOnPage = (this.pagination.page-1)*this.pagination.rowsPerPage;
        const lastOnPage = this.pagination.page*this.pagination.rowsPerPage-1;

        const inRange = pos => pos >= firstOnPage && pos <= lastOnPage
        if (this.selectedPayments.some(it => inRange(this.payments.findIndex(p => p.id === it.id)))) {
          this.selectedPayments = []
        } else {
          this.selectedPayments = this.payments.slice(firstOnPage, lastOnPage).filter(this.shouldSelect).slice()
        }
      },
      async sendPaymentStatements() {
        for (const payment of this.selectedPayments) {
          await this.sendPayment(payment)
        }

        this.selectedPayments = []
      },
      formatDate(date) {
        return date ? moment(date).format('DD MMMM YYYY') : null
      },
      async processSelectedPayments() {
        await this.processPayments(this.selectedPayments);
        this.selectedPayments = []
      },
      showPayment(payment, event) {
        if (payment.id && event.target.tagName.toLowerCase() === 'td') {
          this.$refs.PaymentDlg.open(payment)
        }
      },
      getPaymentParameters(query) {
        return {
          querySearch: query,
          startDate: this.startDate,
          endDate: this.endDate,
        }
      },
      areLastPayments(payment) {
        const NumOfMSecInDay = 24 * 60 * 60 * 1000;
        const lease = this.leaseList.find(lease => lease.id === payment.lease_id);
        if (lease) {
          const checkout_date = new Date(lease.checkout_date)
          const now = new Date()
          const days = Math.floor((checkout_date.getTime() - now.getTime()) / NumOfMSecInDay)
          return days < 30;
        } else {
          return false;
        }
      },
      isPayCash(payment) {
        const lease = this.leaseList.find(lease => lease.id === payment.lease_id);
        if (lease) {
          return lease.house.paycash;
        } else {
          return false;
        }
      },
      isArchived(payment) {
        return payment.payment_pdf_send > 0;
      },
      isValidAccount(payment) {
        return payment.owner_bank_account && payment.owner_bank_account.length > 10;
      },
      shouldSelect(payment) {
        if (payment.disactived && payment.disactived.length > 0) {
          return false;
        }
        if (this.querySearch === 'overdue' || this.querySearch === 'current_week') {
          return !this.areLastPayments(payment);
        } else if (this.querySearch === 'processed') {
          const positive = payment.total_amount >= 0;
          const valid_account = this.isValidAccount(payment);
          return positive && valid_account && !this.isPayCash(payment) && !this.isArchived(payment);
        } else if (this.querySearch === 'bankfiled') {
          const alreadySent = payment.payment_pdf_send
          return !alreadySent;
        } else {
          return false;
        }
      },
      details(payment) {
        const lease = this.leaseList.find(lease => lease.id === payment.lease_id);
        if (!lease) {
          return {iconColor: 'grey', icon: 'error', tooltip: 'unknown lease'};
        }
        const house = lease.house
        // console.log('details: ', {payment, lease, house})
        if (payment.state == 0) {
          const NumOfMSecInDay = 24 * 60 * 60 * 1000;
          const checkout_date = new Date(lease.checkout_date)
          const now = new Date()
          const days = Math.floor((checkout_date.getTime() - now.getTime()) / NumOfMSecInDay)
          const tooltip = `${days} days left to the end of lease`
          const iconColor = (days < 30) ? 'orange' : 'grey';
          const icon = 'error';
          return {iconColor, icon, tooltip};
        } else if (payment.state == 1) {
          const alreadySent = payment.payment_pdf_send
          if (alreadySent === 0) {
            const bankfiled= payment.bankfiled;
            if (bankfiled === 0) {
              const paycash = house.paycash;
              const paydue_time_begin = moment().startOf('week').format('YYYY-MM-DD');
              const overdue = payment.paydue_time < paydue_time_begin;
              const negative = payment.total_amount < 0;
              const is_archived = payment.payment_pdf_send > 0;
              const valid_account = payment.owner_bank_account && payment.owner_bank_account.length > 10;
              const tooltip = is_archived? 'The payment is archived': !valid_account? 'The owner\'s account is invalid': negative? 'The amount is negative': paycash? `To pay in cash`: overdue? `Payment is overdue`: `Pay in this week`
              const iconColor = is_archived? 'primary': negative? 'secondary' : paycash? 'secondary' : overdue? 'red' : 'green';
              const icon = 'done_outline';
              return {iconColor, icon, tooltip};
            } else {
              const pay_timestamp = moment(payment.pay_time).format("DD MMM yyyy")
              const tooltip = `Bank filed at ${pay_timestamp}`
              const iconColor = 'primary';
              const icon = 'archive';
              return {iconColor, icon, tooltip};
            }
          } else if (alreadySent === 1){
            const tooltip = `Payment statement is sent`
            const iconColor = 'primary';
            const icon = 'success';
            return {iconColor, icon, tooltip};
          } else {
            const tooltip = `Failed to send payment statement`
            const iconColor = 'warning';
            const icon = 'error';
            return {iconColor, icon, tooltip};
          }
        } else {
          const tooltip = `Failed to send payment statement`
          const iconColor = 'warning';
          const icon = 'error';
          return {iconColor, icon, tooltip};
        }
      },
      updatePagination(pagination) {
        console.log(pagination);
        this.pagination = pagination;
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~vuetify/src/stylus/settings/_colors';

  .table--fixed >>> .v-table {
    table-layout: fixed !important;
  }
  .payments-layout__menu {
    border-bottom: 1px solid $grey.lighten-2;
  }

  .payment-row:hover {
    background-color : red;
    border-radius: 5px;
    cursor: pointer;
    border-border-color: 5px;
  }

  .container {
    padding: 0;
  }
</style>
